/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesMatchPhaseSchema = z.enum([
  "LobbyPending",
  "LobbyCreated",
  "ChampionSelect",
  "InGame",
  "ResultUploaded",
  "Confirmed",
]);
